
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/storage-moving-and-student-storage",
      function () {
        return require("private-next-pages/storage-moving-and-student-storage/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/storage-moving-and-student-storage"])
      });
    }
  